import _styled from "@emotion/styled-base";
import { bool } from 'prop-types';

var getSize = (_ref, units) => {
  var {
    containToParent
  } = _ref;
  return containToParent ? '100%' : "100".concat(units);
};

var getPosition = _ref2 => {
  var {
    containToParent
  } = _ref2;
  return containToParent ? 'absolute' : 'fixed';
};

var Overlay = _styled("div", {
  target: "e37q8ky0",
  label: "Overlay"
})("background-color:rgba(0,0,0,0.4);height:", props => getSize(props, 'vh'), ";left:0;position:", getPosition, ";top:0;width:", props => getSize(props, 'vw'), ";z-index:9999;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9PdmVybGF5LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVMwQiIsImZpbGUiOiIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Db21tb24vT3ZlcmxheS5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEV4dGVybmFsIExpYnJhcmllc1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgYm9vbCB9IGZyb20gJ3Byb3AtdHlwZXMnO1xuXG5jb25zdCBnZXRTaXplID0gKHsgY29udGFpblRvUGFyZW50IH0sIHVuaXRzKSA9PlxuICBjb250YWluVG9QYXJlbnQgPyAnMTAwJScgOiBgMTAwJHt1bml0c31gO1xuY29uc3QgZ2V0UG9zaXRpb24gPSAoeyBjb250YWluVG9QYXJlbnQgfSkgPT5cbiAgY29udGFpblRvUGFyZW50ID8gJ2Fic29sdXRlJyA6ICdmaXhlZCc7XG5cbmNvbnN0IE92ZXJsYXkgPSBzdHlsZWQuZGl2YFxuICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDAsIDAsIDAsIDAuNCk7XG4gIGhlaWdodDogJHsocHJvcHMpID0+IGdldFNpemUocHJvcHMsICd2aCcpfTtcbiAgbGVmdDogMDtcbiAgcG9zaXRpb246ICR7Z2V0UG9zaXRpb259O1xuICB0b3A6IDA7XG4gIHdpZHRoOiAkeyhwcm9wcykgPT4gZ2V0U2l6ZShwcm9wcywgJ3Z3Jyl9O1xuICB6LWluZGV4OiA5OTk5O1xuYDtcblxuT3ZlcmxheS5wcm9wVHlwZXMgPSB7XG4gIGNvbnRhaW5Ub1BhcmVudDogYm9vbCxcbn07XG5cbmV4cG9ydCB7IE92ZXJsYXkgfTtcbiJdfQ== */"));

Overlay.propTypes = {
  containToParent: bool
};
export { Overlay };